import { createFileRoute } from '@tanstack/react-router';

import { ServicesPageContent } from '@/components/layout/pages/services-page';
import { staticPageHead } from '@/config/seo-head';

export const Route = createFileRoute('/services')({
  head: () => staticPageHead('/services'),
  component: ServicesPageContent,
});
